import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";

interface TabsProps {
    target: string;
}

@Dce("Tabs")
export default class Tabs extends DceComponent<TabsProps> {

    private target: JQuery<HTMLElement>;
    private tabs: JQuery<HTMLElement>;

    constructor(elem: DceHTMLElement, props: TabsProps) {
        super(elem, props);

        this.setupTarget();

        this.tabs = $(this.elem);

        this.tabs.on('click', 'a', e => {
            e.preventDefault();
            let clickedElement = e.target as HTMLElement;

            let tabId = clickedElement.dataset.tab;

            if(!tabId){
                tabId = clickedElement.parentElement.dataset.tab;
            }

            this.tabs.children("a[data-tab]").removeClass('active');
            if(clickedElement.classList.contains('tab')){
                clickedElement.classList.add('active');
            }else{
                $(clickedElement).closest('.tab').addClass('active');
            }

            this.target.children('*[data-tab]').hide();
            this.target.children('*[data-tab=' + tabId +']').show();

            return false;
        })
    }

    protected setupTarget(){
        if(this.props.target == '>'){
            this.target = $(this.elem).next();
        }else{
            this.target = $(this.props.target);
        }
    }

    defaultProps(): Partial<TabsProps> {
        return {
            target: '>'
        }
    }
}
